module.exports = __webpack_public_path__ + "img/the-netherlands-lung-cancer-male.f30458bb.png";